<template>
	<div class="rearview-box">
		<!-- 头部 -->
		<!-- <header class="text-header">2019 In The Rearview</header> -->
		<!-- 头部背景图 -->
		<section class="bg-top-header"></section>

		<!-- 数据获取正常 -->
		<template v-if="enable">
			<!-- 个人头像/基础数据 -->
			<section class="rearview-user">
				<!-- <img class="avatar" :src="userInfo.avatar" /> -->
				<!-- <p class="congratulation">Congratulations!</p> -->
				<p class="text-normal">
					You joined <span class="text-bold-blue">{{ userInfo.installDate | timeFormat }}</span>
				</p>
				<p class="text-normal">
					It's been <span class="text-bold-blue">{{ userInfo.userAge }}</span>
				</p>
				<p class="text-normal">
					You're the <span class="text-bold-blue">{{ userInfo.userRank | moneyFormat }}<sup>th</sup></span> of <span class="text-bold-blue">5,554,233 </span>users
				</p>
			</section>
			<!-- top3 truck stops -->
			<section class="rearview-truckStops">
				<div class="photo-box">
					<div class="photo-card" v-for="{ imgSrc } in imgTruckStopsArr" :key="imgSrc">
						<img :src="imgSrc" alt="" />
					</div>
				</div>
			</section>
			<!-- saving time -->
			<section class="rearview-saving-time">
				<div class="text-box">
					<p class="text-bold">On Average</p>
					<p class="text-normal">
						You Checked Out <span class="text-bold-blue">{{ userInfo.parkingClicked | moneyFormat }} Parking Lots</span>
					</p>
					<p class="text-normal text-short">
						And Saved <span class="text-bold-blue">{{ userInfo.hourSaved | moneyFormat }} Hours</span>
					</p>
				</div>
			</section>
			<!-- 跳转锚点 -->
			<div class="btn-showMeHow-box">
				<p class="text-showMeHow">
					You can save an extra <span class="text-bold-orange">{{ userInfo.premiumHourSave | moneyFormat }} Hours</span>
				</p>
				<a class="btn-showMeHow" href="#freeBtn" @click="timeBtnClick"><i class="icon-down"></i>Show Me How</a>
			</div>
			<!-- saving fuel -->
			<section class="rearview-saving-fuel">
				<p class="text-normal">
					You Checked Out <span class="text-bold-blue">{{ userInfo.gasClicked | moneyFormat }} Gas Stations</span>
				</p>
				<p class="text-normal  text-short">
					And Saved <span class="text-bold-blue">${{ userInfo.fuelSaved | moneyFormat }} in Fuel</span>
				</p>
			</section>
			<!-- 跳转锚点 -->
			<div class="btn-showMeHow-box">
				<p class="text-showMeHow">
					You can save an extra <span class="text-bold-orange">${{ userInfo.premiumFuelSaved | moneyFormat }} in Fuel</span>
				</p>
				<a class="btn-showMeHow" href="#freeBtn" @click="fuelBtnClick"><i class="icon-down"></i>Show Me How</a>
			</div>
			<!-- used times -->
			<section class="rearview-used-time">
				<div class="text-time">
					<p>You used the</p>
					<h1 class="text-bold">Trip Planner</h1>
					<h1 class="text-bold">{{ userInfo.tripPlanned | moneyFormat }} times</h1>
				</div>
				<div class="driving-time">
					<div class="circle">
						<i class="icon-moon"></i>
					</div>
					<p class="text-bold-blue">{{ userInfo.nightPercent | percentFormat }}%</p>
					<p class="text-normal">of your driving was at night</p>
				</div>
			</section>
			<!-- viewed ads -->
			<section class="rearview-used-ads">
				<div class="text-content">
					<h1 class="text-bold">
						You viewed <span class="text-bold-blue">{{ userInfo.adsViewed | moneyFormat }}</span> ads
					</h1>
					<p class="text-simi">
						and<span class="text-simi-blue"> engaged with {{ userInfo.adsClicked | moneyFormat }}</span> of them
					</p>
				</div>
			</section>
			<!-- premium promote -->
			<section class="rearview-premium">
				<header>Using Trucker Path Premium</header>
				<div class="line1"></div>
				<p class="text-have">You Could Have Saved</p>
				<div class="line2"></div>
				<p class="text-normal text-with-icon">
					<i class="clock"></i><span class="text-bold-orange">{{ userInfo.premiumHourSave | moneyFormat }} Hours</span>
				</p>
				<p class="text-grey">*Premium users can easily find open parking spots with Parking Prediction.</p>
				<p class="text-normal text-with-icon">
					<i class="dollar"></i><span class="text-bold-orange">${{ userInfo.premiumFuelSaved | moneyFormat }} in Fuel</span>
				</p>
				<p class="text-grey">*Premium users can save more at the pump with Fuel Optimization.</p>
				<p class="text-normal">Plus, less eyestrain with <span class="text-bold-orange">Night-Mode Navigation</span> and being completely <span class="text-bold-orange">Ad-Free!</span></p>
				<div class="btn-try-free" @click="jumpToOherPage" id="freeBtn">Try 1 Week Free</div>
				<p class="text-semi">It was an honor driving with you See you in 2020!</p>
			</section>
		</template>

		<!-- 数据获取失败 -->
		<template v-else>
			<!-- 基础数据 -->
			<section class="rearview-user">
				<p class="text-normal">By 2020</p>
				<p class="text-normal">The Trucker Path Community grew to over <span class="text-bold-blue">5,500,000 users!</span></p>
				<p class="text-normal">Over <span class="text-bold-blue">400,000 POI </span>places are listed on Trucker Path. Find Parking, Gas, Weigh Stations, and Truck Stops wherever you go.</p>
			</section>
			<!-- top3 truck stops -->
			<section class="rearview-truckStops">
				<div class="photo-box">
					<div class="photo-card" v-for="{ imgSrc } in imgTruckStopsArr" :key="imgSrc">
						<img :src="imgSrc" alt="" />
					</div>
				</div>
			</section>
			<!-- saving time -->
			<section class="rearview-saving-time">
				<div class="text-box">
					<p class="text-bold">On Average</p>
					<p class="text-normal">Users Checked Out <span class="text-bold-blue">202 Parking Lots</span></p>
					<p class="text-normal text-short">And Saved <span class="text-bold-blue">91 Hours</span></p>
				</div>
			</section>
			<!-- 跳转锚点 -->
			<div class="btn-showMeHow-box">
				<p class="text-showMeHow">You can save an extra <span class="text-bold-orange">68 Hours</span></p>
				<a class="btn-showMeHow" href="#freeBtn" @click="timeBtnClick"><i class="icon-down"></i>Show Me How</a>
			</div>
			<!-- saving fuel -->
			<section class="rearview-saving-fuel">
				<p class="text-normal">Users Checked Out <span class="text-bold-blue">304 Gas Stations</span></p>
				<p class="text-normal text-short">And Saved <span class="text-bold-blue">$3,423 in Fuel</span></p>
			</section>
			<!-- 跳转锚点 -->
			<div class="btn-showMeHow-box">
				<p class="text-showMeHow">You can save an extra <span class="text-bold-orange">$1,203 in Fuel</span></p>
				<a class="btn-showMeHow" href="#freeBtn" @click="fuelBtnClick"><i class="icon-down"></i>Show Me How</a>
			</div>
			<!-- premium promote -->
			<section class="rearview-premium">
				<header>Using Trucker Path Premium</header>
				<div class="line1"></div>
				<p class="text-have">Our Members Saved an Extra</p>
				<div class="line2"></div>
				<p class="text-normal text-with-icon"><i class="clock"></i><span class="text-bold-orange">68 Hours</span></p>
				<p class="text-grey">*Premium users can easily find open parking spots with Parking Prediction.</p>
				<p class="text-normal text-with-icon"><i class="dollar"></i><span class="text-bold-orange">$1,203 in Fuel</span></p>
				<p class="text-grey">*Premium users can save more at the pump with Fuel Optimization.</p>
				<p class="text-normal">Plus, less eyestrain with <span class="text-bold-orange">Night-Mode Navigation</span> and being completely <span class="text-bold-orange">Ad-Free!</span></p>
				<div class="btn-try-free" @click="jumpToOherPage" id="freeBtn">Try 1 Week Free</div>
				<p class="text-semi">It was an honor driving with you See you in 2020!</p>
			</section>
		</template>
	</div>
</template>

<script>
import flexible from 'flexible.js'
import moment from 'moment'
import getTPDriverState2020 from '@/api/tpYearReview2020.js'
import mixpanel from '@/utils/mixpanel.js'
import gaSevice from '@/utils/initGA.js'

export default {
	filters: {
		moneyFormat(num) {
			return Number(num).toLocaleString('en-US')
		},
		percentFormat(num) {
			return (Math.round(num * 10 ** 2) / 10 ** 2) * 100
		},
		timeFormat(time) {
			return moment(time)
				.add(1, 'month')
				.format('MMM D, YYYY')
		}
	},
	data() {
		return {
			imgTruckStopsArr: [{ imgSrc: require('@/assets/images/rearview/img-stop-lowa.png') }, { imgSrc: require('@/assets/images/rearview/img-stop-jubitz.png') }, { imgSrc: require('@/assets/images/rearview/img-stop-petro.png') }],
			hybridLink: 'truckerpath://main_promo?source=2019review',
			enable: false,
			userInfo: {
				adsClicked: 0,
				adsViewed: 0,
				deviceId: '',
				distinctId: '',
				enable: false,
				fuelSaved: 0,
				gasClicked: 0,
				hourSaved: 0,
				id: 0,
				installDate: 0,
				nightPercent: 0,
				parkingClicked: 0,
				premiumFuelSaved: 0,
				premiumHourSave: 0,
				tripPlanned: 0,
				userAge: '',
				userId: '',
				userRank: 0
			}
		}
	},
	beforeCreate() {
		mixpanel.initMixpanel('bf00c175ff23c676271a6a6a53109d92')
		gaSevice.addScript()
	},
	created() {
		this.getYearReviewData()
	},
	mounted() {
		flexible(750 * 2)
		mixpanel.track('screenview', {})
		gaSevice.emit('screenview', 'ga2', { screenview: 'screenview' })
	},
	methods: {
		getUrlParam(name) {
			const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
			const r = decodeURI(window.location.search.substr(1)).match(reg)
			if (r != null) {
				return unescape(r[2])
			} else {
				return null
			}
		},
		timeBtnClick() {
			mixpanel.track('parkingcta', {})
		},
		fuelBtnClick() {
			mixpanel.track('gascta', {})
		},
		async getYearReviewData() {
			try {
				let params = {
					userId: this.getUrlParam('userId'),
					deviceId: this.getUrlParam('deviceId') || '',
					distinctId: this.getUrlParam('distinctId')
				}
				const res = await getTPDriverState2020(params)
				const { enable } = res
				this.enable = enable
				if (!enable) return
				this.userInfo = Object.assign(this.userInfo, res)
			} catch (error) {
				return null
			}
		},
		jumpToOherPage() {
			mixpanel.track('1monthcta', {})
			window.location.href = this.hybridLink
		}
	}
}
</script>

<style lang="scss" scoped>
@import '@/scss/rem.scss';

.rearview-box {
	width: rem-base-50(750px);
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin: 0 auto;
	background-color: #f9fafc;
	.text-header {
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: rem-base-50(32px);
		height: rem-base-50(88px);
		background-color: rgba(255, 255, 255, 0);
	}

	.bg-top-header {
		width: rem-base-50(750px);
		height: rem-base-50(900px);
		background: url('../../assets/images/rearview/bg-top-header.jpg') center/100% no-repeat;
	}

	.rearview-user {
		width: 100%;
		position: relative;
		padding-left: rem-base-50(40px);
		padding-top: rem-base-50(90px);
		margin-bottom: rem-base-50(40px);
		background-color: #f9fafc;
		background: url('../../assets/images/rearview/bg-fire.jpg') center/100% no-repeat;

		.avatar {
			position: absolute;
			top: rem-base-50(-70px);
			left: rem-base-50(40px);
			width: rem-base-50(140px);
			height: rem-base-50(140px);
			border-radius: 50%;
			background: red;
		}

		.congratulation {
			height: rem-base-50(46px);
			margin-bottom: rem-base-50(40px);
			font-family: SourceSansPro;
			font-size: rem-base-50(30px);
			line-height: 1.53;
			color: #141a42;
		}

		.text-normal {
			width: rem-base-50(670px);
			margin-bottom: rem-base-50(20px);
			font-family: SourceSansPro;
			font-size: rem-base-50(36px);
			line-height: 1.28;
			color: #141a42;

			.text-bold-blue {
				font-family: SourceSansPro-bold;
				color: #0376ef;

				& > sup {
					vertical-align: super;
					font-size: rem-base-50(28px);
				}
			}
		}
	}

	.rearview-truckStops {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding-bottom: rem-base-50(50px);
		width: 100%;
		height: rem-base-50(1968px);
		background: url('../../assets/images/rearview/bg-truckStops.jpg') center/100% no-repeat;
		background-position: top;
		position: relative;

		.photo-box {
			position: absolute;
			top: rem-base-50(248px);
			left: 0;
		}

		.photo-card {
			width: 100%;
			margin-bottom: rem-base-50(20px);

			& > img {
				width: 100%;
				height: auto;
			}
		}
	}

	.rearview-saving-time {
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		align-items: center;
		position: relative;
		width: 100%;
		height: rem-base-50(1000px);
		background: url('../../assets/images/rearview/bg-saving-time.jpg') center/100% no-repeat;
		margin-bottom: rem-base-50(-140px);

		.text-box {
			display: flex;
			flex-direction: column;
			position: absolute;
			left: rem-base-50(410px);
			bottom: rem-base-50(220px);

			.text-bold {
				width: rem-base-50(300px);
				height: rem-base-50(46px);
				font-family: SourceSansPro;
				font-size: rem-base-50(48px);
				font-weight: 600;
				line-height: 0.96;
				color: #141a42;
				margin-bottom: rem-base-50(30px);
			}

			.text-normal {
				width: rem-base-50(300px);
				height: rem-base-50(92px);
				font-family: SourceSansPro;
				font-size: rem-base-50(36px);
				line-height: 1.28;
				color: #141a42;
				margin-bottom: rem-base-50(30px);

				.text-bold-blue {
					font-family: SourceSansPro-bold;
					color: #0376ef;
				}
			}

			.text-short {
				width: rem-base-50(190px);
			}
		}
	}

	.btn-showMeHow-box {
		display: flex;
		justify-content: center;
		align-items: center;
		width: rem-base-50(710px);
		height: rem-base-50(140px);
		border-radius: rem-base-50(10px);
		box-shadow: 0 rem-base-50(6px) rem-base-50(19px) 0 rgba(0, 87, 169, 0.09);
		background-color: #ffffff;
		z-index: 2;

		.text-showMeHow {
			width: rem-base-50(300px);
			height: rem-base-50(70px);
			font-family: SourceSansPro;
			font-size: rem-base-50(30px);
			line-height: 1.17;
			color: #141a42;
			margin-right: rem-base-50(10px);

			.text-bold-orange {
				font-family: SourceSansPro-bold;
				color: #fa4b05;
			}
		}

		.btn-showMeHow {
			display: flex;
			justify-content: center;
			align-items: center;
			width: rem-base-50(280px);
			height: rem-base-50(68px);
			border-radius: rem-base-50(80px);
			background-color: #0376ef;
			font-family: SourceSansPro;
			font-size: rem-base-50(30px);
			font-weight: 600;
			color: #ffffff;
			cursor: pointer;

			.icon-down {
				width: rem-base-50(30px);
				height: rem-base-50(30px);
				background: url('../../assets/images/rearview/icon-down.svg') center/100% no-repeat;
				margin-right: rem-base-50(9px);
			}

			&:hover {
				opacity: 0.7;
			}
		}
	}

	.rearview-saving-fuel {
		margin-top: rem-base-50(80px);
		width: 100%;
		height: rem-base-50(818.7px);
		padding-top: rem-base-50(170px);
		padding-left: rem-base-50(40px);
		background: url('../../assets/images/rearview/bg-save-fuel.jpg') center/100% no-repeat;

		.text-normal {
			width: rem-base-50(300px);
			margin-bottom: rem-base-50(40px);
			font-family: SourceSansPro;
			font-size: rem-base-50(36px);
			line-height: 1.28;
			color: #141a42;

			.text-bold-blue {
				font-family: SourceSansPro-bold;
				color: #0376ef;
			}
		}

		.text-short {
			width: rem-base-50(220px);
		}
	}

	.rearview-used-time {
		width: rem-base-50(670px);
		margin-top: rem-base-50(100px);
		margin-left: rem-base-50(80px);
		height: rem-base-50(1000px);
		background: url('../../assets/images/rearview/bg-used-time.jpg') center/100% no-repeat;
		position: relative;

		.text-time {
			position: absolute;
			top: rem-base-50(60px);
			right: rem-base-50(40px);
			width: rem-base-50(393px);
			height: rem-base-50(174px);
			font-family: Gotham-Book;
			font-size: rem-base-50(36px);
			line-height: 1.21;
			letter-spacing: rem-base-50(-0.3px);
			text-align: right;
			color: #ffffff;

			.text-bold {
				font-size: rem-base-50(48px);
				font-family: Gotham-Bold;
				letter-spacing: rem-base-50(-0.4px);
			}
		}

		.driving-time {
			display: flex;
			flex-direction: column;
			align-items: center;
			width: rem-base-50(360px);
			height: rem-base-50(320px);
			border-radius: rem-base-50(10px);
			box-shadow: 0 6px 19px 0 rgba(0, 87, 169, 0.09);
			background-color: #323f5d;
			position: absolute;
			bottom: rem-base-50(80px);
			left: rem-base-50(-40px);

			.circle {
				display: flex;
				align-items: center;
				justify-content: center;
				width: rem-base-50(112px);
				height: rem-base-50(112px);
				margin-top: rem-base-50(30px);
				border-radius: 50%;
				background-color: #0376ef;

				.icon-moon {
					display: block;
					width: 28px;
					height: 28px;
					background: url('../../assets/images/rearview/night.svg') center/100% no-repeat;
				}
			}

			.text-bold-blue {
				height: rem-base-50(44px);
				font-family: Gotham-Bold;
				font-size: rem-base-50(36px);
				color: #ffffff;
				margin: rem-base-50(15px) 0;
			}

			.text-normal {
				width: rem-base-50(270px);
				height: rem-base-50(70px);
				font-family: SourceSansPro;
				font-size: rem-base-50(30px);
				line-height: 1.17;
				text-align: center;
				color: #ffffff;
			}
		}
	}

	.rearview-used-ads {
		width: 100%;
		height: rem-base-50(680px);
		margin-top: rem-base-50(100px);
		position: relative;
		background: url('../../assets/images/rearview/bg-viewed-ads.jpg') center/100% no-repeat;

		.text-content {
			position: absolute;
			top: rem-base-50(80px);
			left: rem-base-50(40px);

			.text-bold {
				width: rem-base-50(350px);
				height: rem-base-50(116px);
				font-family: Gotham-Bold;
				font-size: rem-base-50(48px);
				line-height: 1.21;
				letter-spacing: -rem-base-50(0.4px);
				color: #141a42;

				.text-bold-blue {
					font-family: Gotham-Bold;
					color: #0376ef;
				}
			}

			.text-simi {
				width: rem-base-50(320px);
				height: rem-base-50(92px);
				font-family: Gotham-Book;
				font-size: rem-base-50(36px);
				color: #141a42;
				line-height: 1.28;
				letter-spacing: -rem-base-50(0.3px);

				.text-simi-blue {
					color: #0376ef;
				}
			}
		}
	}

	.rearview-premium {
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding: 0 rem-base-50(40px);
		position: relative;
		margin-top: rem-base-50(80px);
		& > header {
			align-self: flex-start;
			width: rem-base-50(466px);
			height: rem-base-50(116px);
			font-family: Gotham-Bold;
			font-size: rem-base-50(48px);
			line-height: 1.21;
			letter-spacing: rem-base-50(-0.4px);
			color: #141a42;
		}

		& > p {
			align-self: flex-start;
			text-align: left;
			font-family: Gotham-Book;
			font-size: rem-base-50(36px);
			line-height: 1.28;
			letter-spacing: -rem-base-50(0.3px);
			color: #141a42;
		}

		.line1 {
			position: absolute;
			top: rem-base-50(80px);
			left: rem-base-50(270px);
			width: rem-base-50(60px);
			height: 1px;
			opacity: 0.5;
			background-color: #7c8698;
		}

		.line2 {
			align-self: flex-start;
			width: rem-base-50(120px);
			margin-top: rem-base-50(20px);
			margin-bottom: rem-base-50(40px);
			height: 1px;
			opacity: 0.5;
			background-color: #7c8698;
		}

		.clock {
			display: block;
			width: rem-base-50(48px);
			height: rem-base-50(48px);
			margin-right: rem-base-50(15px);
			background: url('../../assets/images/rearview/clock.svg') center/100% no-repeat;
		}

		.dollar {
			display: block;
			width: rem-base-50(48px);
			height: rem-base-50(48px);
			margin-right: rem-base-50(15px);
			background: url('../../assets/images/rearview/dollar.svg') center/100% no-repeat;
		}

		.text-with-icon {
			display: flex;
		}

		.text-normal {
			width: rem-base-50(670px);
			font-family: SourceSansPro;
			font-size: rem-base-50(36px);
			color: #141a42;
			line-height: 1.28;
			margin-bottom: rem-base-50(10px);

			.text-bold-orange {
				font-family: SourceSansPro-bold;
				color: #fa4b05;
			}
		}

		.text-grey {
			width: rem-base-50(670px);
			height: rem-base-50(70px);
			font-family: SourceSansPro;
			font-size: rem-base-50(30px);
			line-height: 1.17;
			color: #7c8698;
			margin-bottom: rem-base-50(30px);
		}

		.text-semi {
			align-self: center;
			width: rem-base-50(420px);
			height: rem-base-50(70px);
			font-family: SourceSansPro;
			font-size: rem-base-50(30px);
			line-height: 1.17;
			text-align: center;
			color: #141a42;
			margin-bottom: rem-base-50(30px);
		}

		.text-have {
			width: 100%;
			height: rem-base-50(46px);
			font-family: Gotham-Book;
			font-size: rem-base-50(36px);
			line-height: 1.28;
			letter-spacing: -rem-base-50(0.3px);
			color: #141a42;
		}

		.btn-try-free {
			display: flex;
			justify-content: center;
			align-items: center;
			width: rem-base-50(670px);
			height: rem-base-50(86px);
			border-radius: rem-base-50(10px);
			background-color: #0376ef;
			font-family: SourceSansPro;
			font-size: rem-base-50(36px);
			font-weight: 600;
			color: #ffffff;
			margin-bottom: rem-base-50(30px);
			margin-top: rem-base-50(50px);
			cursor: pointer;

			&:hover {
				opacity: 0.7;
			}
		}
	}
}
</style>